import { render, staticRenderFns } from "./SnippetPreview.vue?vue&type=template&id=51db834b&scoped=true&"
import script from "./SnippetPreview.vue?vue&type=script&lang=js&"
export * from "./SnippetPreview.vue?vue&type=script&lang=js&"
import style0 from "./SnippetPreview.vue?vue&type=style&index=0&id=51db834b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51db834b",
  null
  
)

export default component.exports